import React from "react";
import { Box, Button, SxProps } from "@mui/material";
import downarrow from "../assets/images/downarrow.png";

type Props = {
  open: boolean
  sx?: SxProps;
  onClick?: () => void
}

const ReadMore: React.FC<Props> = ({open, sx, onClick}) => {
  if (!open) return (<></>);

  return (
    <Box
      sx={{...{
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
      }, ...sx}}
    >
      <Button onClick={onClick}>
        <img
          src={downarrow}
          alt="もっと見る"
          style={styles.readMoreArrow}
        />
      </Button>
    </Box>
  )
}
export default ReadMore;

const styles = {
  readMoreArrow: { width: 20, height: 20, margin: 15 },
}
